var lastSelectedCreditCardType;

var MODULE = (function (library, $) {

    $(function () {
        $(".j-cmbCreditCardTypes").on('change', function (e) {

            if (lastSelectedCreditCardType) {
                $(".j-" + lastSelectedCreditCardType + "-image").hide();
            }
            $(".j-" + $(this).val() + "-image").show();
            lastSelectedCreditCardType = $(this).val();
        });
    });
    return library;
})(MODULE || {}, jQuery);

$(document).ready(function () {

    var paymentMethod = $(".j-cmbCreditCardTypes").val();

    if (paymentMethod !== '' ) {
        $(".j-" + paymentMethod + "-image").show();
    }
    lastSelectedCreditCardType = paymentMethod;

});